import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastService } from '../../services/toast.service';
import { AuthService } from '../services/auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(ToastService);
  const authService = inject(AuthService);

  // Endpoints públicos (cliente sin login): no levantamos toast genérico ni intentamos
  // refrescar la sesión — el componente público maneja sus propios mensajes y
  // checkSession() le tira la sesión inexistente al cliente, lo cual da una pantalla rota.
  const isPublic = req.url.includes('/public/');
  const isSesionCheck = req.url.includes('/auth/sesiones');
  const isPagosCheck = req.url.includes('/pagos/suscripcion');

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMessage = 'Ocurrió un error inesperado';

      if (isPublic || isSesionCheck || isPagosCheck) {
        return throwError(() => error);
      }

      if (error.status === 400) {
        errorMessage = error.error?.message || 'Solicitud incorrecta';
        
        // Caso específico: Falta sucursal_id
        if (errorMessage.toLowerCase().includes('sucursal_id') || errorMessage.toLowerCase().includes('sucursalid')) {
          toast.show('Contexto de sucursal perdido. Refrescando sesión...', 'warning');
          // Intentar refrescar la sesión automáticamente
          authService.checkSession();
        } else {
          toast.show(errorMessage, 'error');
        }
      } else if (error.status === 401 || error.status === 403) {
        errorMessage = 'Sesión expirada o sin permisos';
        toast.show(errorMessage, 'error');
        // authService.logout(); // Podría ser muy agresivo, mejor solo avisar o checkSession
        authService.checkSession();
      } else if (error.status === 404) {
        errorMessage = 'Recurso no encontrado';
      } else if (error.status === 500) {
        errorMessage = 'Error interno del servidor';
        toast.show(errorMessage, 'error');
      }

      return throwError(() => error);
    })
  );
};
